export const typeList = [
  {
    "key": "H5订单",
    "value": "h5"
  },
  {
    "key": "web订单",
    "value": "web"
  },
  {
    "key": "自助点餐APP",
    "value": "candaoapp"
  },
  {
    "key": "呼叫中心",
    "value": "callcenter"
  },
  {
    "key": "饿了么",
    "value": "ele"
  },
  {
    "key": "美团",
    "value": "mt"
  },
  {
    "key": "饿了么星选",
    "value": "elestar"
  },
  {
    "key": "点我吧",
    "value": "dwb"
  },
  {
    "key": "京东到家",
    "value": "jddj"
  },
  {
    "key": "邻趣",
    "value": "linqu"
  },
  {
    "key": "到家美食",
    "value": "daojia"
  },
  {
    "key": "有赞商城",
    "value": "youzan"
  },
  {
    "key": "美团点评",
    "value": "mtdp"
  },
  {
    "key": "口碑",
    "value": "kb"
  },
  {
    "key": "饿百零售",
    "value": "eb"
  },
  {
    "key": "美团堂食",
    "value": "mtts"
  },
  {
    "key": "天猫",
    "value": "tmall"
  },
  {
    "key": "滴滴外卖",
    "value": "didi"
  },
  {
    "key": "美团智慧餐厅",
    "value": "zhct"
  },
  {
    "key": "美团新零售",
    "value": "mtls"
  },
  {
    "key": "美团点评拼好饭",
    "value": "mtphf"
  },
  {
    "key": "盒马鲜生",
    "value": "hema"
  },
  {
    "key": "食派士",
    "value": "sherpa"
  },
  {
    "key": "天猫超市",
    "value": "tmallcs"
  },
  {
    "key": "有赞零售",
    "value": "yzls"
  },
  {
    "key": "微信小店",
    "value": "wxxd"
  },
  {
    "key": "顺丰一站",
    "value": "sfyz"
  },
  {
    "key": "锦食送",
    "value": "jshs"
  },
  {
    "key": "秀餐",
    "value": "xiucan"
  },
  {
    "key": "世通",
    "value": "seito"
  },
  {
    "key": "NCR",
    "value": "ncr"
  },
  {
    "key": "简24",
    "value": "jian24"
  },
  {
    "key": "Yitunnel",
    "value": "yitunnel"
  },
  {
    "key": "微信小程序",
    "value": "weixin-xcx"
  },
  {
    "key": "支付宝小程序",
    "value": "zfb-xcx"
  },
  {
    "key": "抖音小程序",
    "value": "douyin-xcx"
  },
  {
    "key": "第三方POS",
    "value": "pos"
  },
  {
    "key": "第三方自动点餐机",
    "value": "kiosk"
  },
  {
    "key": "智能柜",
    "value": "cabinet"
  },
  {
    "key": "易订小程序",
    "value": "yiding"
  },
  {
    "key": "文科软小程序",
    "value": "wkr"
  },
  {
    "key": "炸鸡小镇公众号",
    "value": "zjxz"
  },
  {
    "key": "efc外卖",
    "value": "eatforcharity"
  },
  {
    "key": "琰通小程序",
    "value": "yantong"
  },
  {
    "key": "煜鼎源小程序",
    "value": "ydy"
  },
  {
    "key": "超链小程序",
    "value": "chaolian"
  },
  {
    "key": "智汇方象小程序",
    "value": "zhfx"
  },
  {
    "key": "地心引力小程序",
    "value": "dxyl"
  },
  {
    "key": "千猪小程序",
    "value": "qianzhu"
  },
  {
    "key": "胖芷小程序",
    "value": "pangzhi"
  },
  {
    "key": "文和友小程序",
    "value": "why"
  },
  {
    "key": "随行付小程序",
    "value": "sxf"
  },
  {
    "key": "中皖知托付",
    "value": "zwztf"
  },
  {
    "key": "企迈小程序",
    "value": "qimai"
  },
  {
    "key": "斯慧小程序",
    "value": "sihui"
  },
  {
    "key": "客至小程序",
    "value": "kezhi"
  },
  {
    "key": "有赞POS",
    "value": "yzpos"
  },
  {
    "key": "序多多小程序",
    "value": "xdd"
  },
  {
    "key": "创米云小程序",
    "value": "cmy"
  },
  {
    "key": "聚客蜂小程序",
    "value": "jkf"
  },
  {
    "key": "广州米讯小程序",
    "value": "gzmx"
  },
  {
    "key": "奥琦玮小程序",
    "value": "aqw"
  },
  {
    "key": "客如云pos",
    "value": "kry"
  },
  {
    "key": "马应龙小程序",
    "value": "myl"
  },
  {
    "key": "银豹pos",
    "value": "pospal"
  },
  {
    "key": "蚕小豆云店小程序",
    "value": "cxdyd"
  },
  {
    "key": "天店通小程序",
    "value": "tdt"
  },
  {
    "key": "讯联小程序",
    "value": "xunlian"
  },
  {
    "key": "一千零一夜小程序",
    "value": "yqlyy"
  },
  {
    "key": "微盟小程序",
    "value": "weimeng"
  },
  {
    "key": "凯翼小程序",
    "value": "kaiyi"
  },
  {
    "key": "5I小程序",
    "value": "5i"
  },
  {
    "key": "超链H5",
    "value": "clH5"
  },
  {
    "key": "爱宝",
    "value": "aibao"
  },
  {
    "key": "鲸云客小程序",
    "value": "jyk"
  },
  {
    "key": "食派士小程序",
    "value": "sps"
  },
  {
    "key": "百联小程序",
    "value": "bailian"
  },
  {
    "key": "享拓小程序",
    "value": "xiangtuo"
  },
  {
    "key": "老乡鸡微信小程序",
    "value": "lxjwx"
  },
  {
    "key": "智卡汇小程序",
    "value": "zkh"
  },
  {
    "key": "火炬木小程序",
    "value": "huojumu"
  },
  {
    "key": "鲜丰小程序",
    "value": "xianfeng"
  },
  {
    "key": "鲜丰中台",
    "value": "xfzt"
  },
  {
    "key": "微蚁云",
    "value": "wyy"
  },
  {
    "key": "popeat",
    "value": "pos eat"
  }
]